import React, { ReactElement } from 'react';

import { classNames } from '@/helpers/classNames';
import constants from '@/theme/exportedVariables.module.scss';
import { useMediaQuery } from '@material-ui/core';

import { ChipProps } from './Chip';
import styles from './ChipList.module.scss';

export interface ChipListProps {
	children: ReactElement<ChipProps> | ReactElement<ChipProps>[];
	scrollable?: boolean;
	className?: string;
}

export const ChipList = ({
	children,
	scrollable,
	className,
}: ChipListProps) => {
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	return (
		<div
			className={classNames([
				styles['chip-list'],
				scrollable && styles['scrollable'],
				scrollable && isTablet && styles['scroll-padding'],
				className,
			])}
		>
			{children}
		</div>
	);
};
